const tabEnteteMembersCsvFile = [
  {
    cle: "type",
    label: "Type",
    width: "90px",
    textAlign: "left",
    verticalAlign: "middle",
    fontWeight: "",
  },
  {
    cle: "period",
    label: "Période",
    width: "80px",
    textAlign: "left",
    verticalAlign: "middle",
  },
  {
    cle: "name",
    label: "Nom",
    width: "200px",
    textAlign: "left",
    verticalAlign: "middle",
    fontWeight: "bold",
  },
  {
    cle: "surname",
    label: "Prénom",
    width: "100px",
    textAlign: "left",
    verticalAlign: "middle",
    fontWeight: "bold",
  },
  {
    cle: "gender",
    label: "Genre",
    width: "70px",
    textAlign: "center",
    verticalAlign: "middle",
    fontWeight: "",
  },
  {
    cle: "nationality",
    label: "Nationalité",
    width: "110px",
    textAlign: "center",
    verticalAlign: "middle",
    fontWeight: "",
  },
  {
    cle: "licence",
    label: "Licence",
    width: "90px",
    textAlign: "center",
    verticalAlign: "middle",
    fontWeight: "",
  },
  {
    cle: "l",
    label: "L",
    width: "25px",
    textAlign: "center",
    verticalAlign: "middle",
    fontWeight: "",
  },
  {
    cle: "year",
    label: "Année",
    width: "70px",
    textAlign: "center",
    verticalAlign: "middle",
    fontWeight: "",
  },
  {
    cle: "birthDate",
    label: "Date de naissance",
    width: "120px",
    textAlign: "center",
    verticalAlign: "middle",
    fontWeight: "",
  },
  {
    cle: "category",
    label: "Catégorie d'âge",
    width: "100px",
    textAlign: "center",
    verticalAlign: "middle",
    fontWeight: "",
  },
  {
    cle: "residence",
    label: "Résidence",
    width: "200px",
    textAlign: "left",
    verticalAlign: "middle",
    fontWeight: "",
  },
  {
    cle: "street",
    label: "Rue",
    width: "300px",
    textAlign: "left",
    verticalAlign: "middle",
    fontWeight: "",
  },
  {
    cle: "zip",
    label: "Code postal",
    width: "100px",
    textAlign: "center",
    verticalAlign: "middle",
    fontWeight: "",
  },
  {
    cle: "city",
    label: "Ville",
    width: "200px",
    textAlign: "left",
    verticalAlign: "middle",
    fontWeight: "",
  },
  {
    cle: "homeTel",
    label: "Téléphone domicile",
    width: "150px",
    textAlign: "center",
    verticalAlign: "middle",
    fontWeight: "",
  },
  {
    cle: "persoTel",
    label: "Téléphone personnel",
    width: "150px",
    textAlign: "center",
    verticalAlign: "middle",
    fontWeight: "",
  },
  {
    cle: "email",
    label: "Email",
    width: "300px",
    textAlign: "left",
    verticalAlign: "middle",
    fontWeight: "",
  },
  {
    cle: "secHour",
    label: "2ème heure",
    width: "100px",
    textAlign: "center",
    verticalAlign: "middle",
    fontWeight: "",
  },
  {
    cle: "pickleball",
    label: "Pickleball",
    width: "100px",
    textAlign: "center",
    verticalAlign: "middle",
    fontWeight: "",
  },
  {
    cle: "keyExt",
    label: "Clé Extérieure",
    width: "100px",
    textAlign: "center",
    verticalAlign: "middle",
    fontWeight: "",
  },
  {
    cle: "BadgeInt",
    label: "Badge Salle",
    width: "100px",
    textAlign: "center",
    verticalAlign: "middle",
    fontWeight: "",
  },
];

export default tabEnteteMembersCsvFile;
